import axios from 'axios';

import API_BASE_URL from '../config/api';

const API_URL = `${API_BASE_URL}/api`;

export const contactAPI = {
  submit: (data) => axios.post(`${API_URL}/contacts`, data),
  getAll: () => axios.get(`${API_URL}/contacts`)
};

export const blogAPI = {
  getAll: () => axios.get(`${API_URL}/blogs`),
  getById: (id) => axios.get(`${API_URL}/blogs/${id}`),
  create: (data) => axios.post(`${API_URL}/blogs`, data)
};

export const specializationAPI = {
  getAll: () => axios.get(`${API_URL}/specializations`).then(res => res.data),
  getBySlug: (slug) => axios.get(`${API_URL}/specializations/slug/${slug}`).then(res => res.data)
};

export const industryAPI = {
  getAll: () => axios.get(`${API_URL}/industries`).then(res => res.data),
  getBySlug: (slug) => axios.get(`${API_URL}/industries/${slug}`).then(res => res.data)
};

export const serviceAPI = {
  getAll: () => axios.get(`${API_URL}/services`),
  getBySlug: (slug) => axios.get(`${API_URL}/services/${slug}`)
};
